import { AttributeCondition, AttributeModel, DomainValueModel } from '../models/attribute.model';

export type TranslateFunction = (key: string) => string;

export const getMapAttributeConditionLabel = (t: TranslateFunction): Record<AttributeCondition, string> => ({
  [AttributeCondition.UNDEFINED]: t('plan.attributesView.condition.undefined'),
  [AttributeCondition.GOOD]: t('plan.attributesView.condition.good'),
  [AttributeCondition.AVERAGE_GOOD]: t('plan.attributesView.condition.average_good'),
  [AttributeCondition.AVERAGE_BAD]: t('plan.attributesView.condition.average_bad'),
  [AttributeCondition.BAD]: t('plan.attributesView.condition.bad'),
});

export const attributePresenterFactory = (attribute: AttributeModel) => {
  switch (attribute.type) {
    case 'number':
      return new AttributeNumberPresenter(attribute);
    case 'date':
      return new AttributeDatePresenter(attribute);
    case 'condition':
      return new AttributeConditionPresenter(attribute);
    default:
      return new AttributeStringPresenter(attribute);
  }
};

export class AttributePresenter {
  public readonly name: string;
  public readonly isEditable: boolean;
  public readonly id: string;
  public readonly componentId: string;
  public readonly domainValues: DomainValuePresenter[];
  protected readonly _value: any;

  constructor(attribute: AttributeModel) {
    this.name = attribute.name;
    this.isEditable = attribute.isEditable;
    this.id = attribute.id;
    this.componentId = attribute.componentId;
    this.domainValues = attribute.domainValues.map((domainValue) => new DomainValuePresenter(domainValue));
    this._value = attribute.value;
  }

  get value(): any {
    return this._value;
  }
}

export class AttributeStringPresenter extends AttributePresenter {
  get value(): string {
    return this._value as string;
  }
}

export class AttributeNumberPresenter extends AttributePresenter {
  get value(): number {
    return Number(this._value);
  }
}

export class AttributeDatePresenter extends AttributePresenter {
  get value(): string {
    const dateAsString = this._value as string;
    return dateAsString.split('/').reverse().join('-');
  }
}

export class AttributeConditionPresenter extends AttributePresenter {
  get value(): AttributeCondition {
    return Number(this._value) as AttributeCondition;
  }
}

export class DomainValuePresenter {
  public readonly rank: number;
  public readonly code: string;
  public readonly value: string;

  constructor(domainValue: DomainValueModel) {
    this.rank = domainValue.rank;
    this.code = domainValue.code;
    this.value = domainValue.value;
  }
}
